import { requestJson, buildQuery } from "./apiClient";

export function listCurrentLegalDocuments(params) {
  return requestJson(`/api/legal/documents/current${buildQuery(params)}`);
}

export function getLegalDocument(documentType, version) {
  if (version) {
    return requestJson(`/api/legal/documents/${documentType}/${version}`);
  }

  return requestJson(`/api/legal/documents/${documentType}`);
}
